<template>
  <div class="about-small-animation">
    <div class="about-small-animation__inner">
      <img
        :class="`about-small-animation__img${i}`"
        ref="img"
        v-for="(img, i) in images"
        :src="`/img/${img}.png`"
        :key="i"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        'main-page-image-sm-0',
        'main-page-image-sm-1',
        'main-page-image-sm-2',
        'main-page-image-sm-3',
        'main-page-image-sm-4',
        'main-page-image-sm-5',
        'main-page-image-sm-6',
        'main-page-image-sm-7',
        'main-page-image-sm-8',
        'main-page-image-sm-9'
      ]
    }
  },
  props: {
    position: {
      type: Object,
      required: true
    }
  },
  watch: {
    position(value) {
      if (value) {
        const elsArr = this.$refs.img

        elsArr.forEach((el, i) => {
          TweenMax.to(el, 0.1, {
            x: this.position.x * 0.01 * ++i,
            y: this.position.y * -0.01 * ++i,
            rotation: this.position.x * 0.01,
            ease: Power2.easeInOut
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
.about-small-animation {
  display: none;
}

@include media-min($desktop-width) {
  .about-small-animation {
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;

    &__inner {
      position: absolute;
      bottom: 149px;
      left: 88px;
      width: 368px;
      height: 287px;
    }

    img {
      position: absolute;
    }

    &__img0 {
      bottom: 0;
      left: 0;
    }

    &__img1 {
      top: 0;
      left: 50%;
    }

    &__img2 {
      bottom: 0;
      left: 55%;
    }

    &__img3 {
      right: 22%;
      bottom: 5%;
    }

    &__img7 {
      top: 50%;
      right: 40%;
    }

    &__img5 {
      top: 45%;
      left: 10%;
    }

    &__img6 {
      top: 15%;
      left: 0%;
    }

    &__img4 {
      top: 7%;
      right: 20%;
    }

    &__img8 {
      bottom: 30%;
      left: 0;
    }

    &__img9 {
      right: 20%;
      bottom: 30%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AboutPageSmallAnimation.vue